import { MessageFormatElement } from 'react-intl';

const flattenMessages = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  nestedMessages: Record<string, any>,
  prefix = '',
):
  | Record<string, string>
  | Record<string, MessageFormatElement[]>
  | undefined =>
  Object.keys(nestedMessages).reduce((msgs: Record<string, string>, key) => {
    const messages = msgs;
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (
      key === 'schema' ||
      typeof value === 'string' ||
      typeof value === 'number' ||
      typeof value === 'boolean' ||
      Array.isArray(value)
    ) {
      messages[prefixedKey] = value;
    } else if (typeof value === 'object' && value !== null) {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }

    return messages;
  }, {} as Record<string, string>);

export default flattenMessages;
